import { ThemeProvider } from '@mui/material'
import { SnackbarProvider } from 'notistack'
import type { ReactNode } from 'react'

import { AuthProvider } from '../contexts/auth'
import theme from '../styles/theme'

export default function Providers({ children }: { children: ReactNode }) {
	return (
		<ThemeProvider theme={theme}>
			<AuthProvider>
				<SnackbarProvider
					anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
					maxSnack={3}
					autoHideDuration={2000}
				>
					{children}
				</SnackbarProvider>
			</AuthProvider>
		</ThemeProvider>
	)
}
